import React from "react";
import { useTranslation } from "react-i18next";
import { Focus } from "lucide-react";
import BaseBadge from "@reusables/BaseBadge";

interface LocationLabelProperties {
    storeName: string;
    sectionName?: string;
    isDefault: boolean;
}

/**
 * Location cell of the Locations tab tables: "Store - Section" with a "Default" badge for the default location.
 */
export default function LocationLabel(props: LocationLabelProperties) {
    const { t } = useTranslation("", { keyPrefix: "products.viewEditProduct.tabs.locations" });

    return (
        <div className={"flex items-center space-x-2"}>
            <div>
                <span className="bold-highlight">{props.storeName}</span>
                {props.sectionName ? ` - ${props.sectionName}` : null}
            </div>
            {props.isDefault && (
                <BaseBadge>
                    <div className={"flex items-center space-x-1"}>
                        <Focus size={12} />
                        <span>{t("badges.default")}</span>
                    </div>
                </BaseBadge>
            )}
        </div>
    );
}
